import { attach } from 'perimeterx-axios-interceptor';
import { logger, stats } from '@fiverr-private/obs';
import { enrichment } from './enrichment';
import { reportInterceptAfterSolve, updateSolveSuccess } from './challengeCookie';
import {
    INTERCEPTOR_EVENTS,
    INTERCEPTOR_MESSAGES,
    LOG_CODE,
    IGNORE_PATTERN
} from './constants';

/**
 * Create a stat metric entry
 * @param {String} key Unique metric key
 * @returns {Promise}
 */
const count = (key) => stats.count('axios.interceptor.perimeterx', key);

/**
 * Attach Axios interceptor
 * @param {Axios} axios - The axios instance to attach the interceptor to
 */
const register = (axios) => {
    if (!axios) { return; }

    // Attach PerimeterX interceptor
    attach(axios, {

        /**
         * Should this route being blocked result in the user view the exonerate GUI
         * @param {String} options.path
         * @returns {Boolean}
         */
        filter: ({ path }) => !IGNORE_PATTERN.test(path.replace(/^https:\/\/\w{2,4}\.fiverr\.com/, '')),

        /**
         * Report blocked request interception
         * Track challenge solvers via cookie
         * @param {Request} request Original request
         * @returns {void}
         */
        onintercept: (request) => {
            const type = INTERCEPTOR_EVENTS.INTERCEPT;
            count(type);

            logger.force.info({
                message: INTERCEPTOR_MESSAGES[type],
                code: LOG_CODE,
                type,
                url: request.url
            }, enrichment());
            reportInterceptAfterSolve(request);
        },

        /**
         * Report ignored blocked request interception
         * @param {Request} request Original request
         */
        onignore: (request) => {
            const type = INTERCEPTOR_EVENTS.IGNORE;
            count(type);
            logger.force.info({
                message: INTERCEPTOR_MESSAGES[type],
                code: LOG_CODE,
                type,
                url: request.url
            }, enrichment());
        },

        /**
         * Report successful exoneration process
         * Add / Update cookie for tracking challenge solvers
         * @param {Request} request Original request
         */
        onsuccess: (request) => {
            const type = INTERCEPTOR_EVENTS.SUCCESS;
            count(type);
            logger.force.info({
                message: INTERCEPTOR_MESSAGES[type],
                code: LOG_CODE,
                type,
                url: request.url
            }, enrichment());
            updateSolveSuccess();
        },

        /**
         * Report unsuccessful exoneration process
         * @param {Request} request Original request
         * @param {Error} error Error thrown by axios
         */
        onfailure: (request, error) => {
            const type = INTERCEPTOR_EVENTS.FAILURE;
            count(type);
            logger.force.error(error, Object.assign({
                message: INTERCEPTOR_MESSAGES[type],
                code: LOG_CODE,
                type,
                url: request.url
            }, enrichment()));
        },

        /**
         * Report failure in the process
         * @param {Error} error Error thrown by exoneration process
         */
        onerror: (error) => setTimeout(() => {
            if (error.code === 'UNSUPPORTED_BROWSER') {
                return;
            }

            error.code = 'AXIOS_INTERCEPTOR_ERROR';
            throw error;
        }),

        modalConfig: { timeout: 6000 }
    });
};

export default register;
